// extracted by mini-css-extract-plugin
module.exports = {"wrap":"dataImportPage_wrap__2nEOJ"};